<template>
  <sweet-modal ref="modal" overlay-theme="light" @close="closeModal">
    <div class="row">
      <div class="col-12 col-md-8 offset-md-2 text-left">
        <div class="share-profile-box">
          <label>{{ $t('message.professional.menu.share') }}</label>
          <div class="text-remark" v-if="profile">
            <label>
              <span v-if="profileType === 'experience'">
                {{ profile.title }}
              </span>
              <span v-else>
                {{ $t('message.professional.share_profile_remark') }} {{ profile.name | firstName }}
              </span>
            </label>
            {{ $t('message.in') }}
            {{ globalState.cities[profile.province_id] | multiLangName }}
          </div>
        </div>
        <div class="share-profile-box">
          <a href="" @click.prevent="fbShare" class="text-primary-link">
            <i class="fab fa-facebook social-icon"></i>Facebook
          </a>
        </div>
        <div class="share-profile-box">
          <a :href="twitterShareUrl" target="_blank" class="text-primary-link">
            <i class="fab fa-twitter social-icon"></i>Twitter
          </a>
        </div>
        <!--
        <div class="share-profile-box">
          <a href="" @click.prevent="fbShare" class="text-primary-link">
            <i class="fas fa-envelope social-icon"></i>Email
          </a>
        </div>
        -->
        <div class="share-profile-box">
          <a href="" @click.prevent="copyLink" v-clipboard:copy="shareUrl" class="text-primary-link">
            <i class="fas fa-clipboard social-icon"></i>{{ $t(isCopiedLink) }}
          </a>
        </div>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'

export default {
  components: {
    SweetModal
  },
  data () {
    return {
      shareUrl: '',
      shareText: '',
      twitterShareUrl: '',
      isCopiedUrl: false,
      profile: null,
      profileType: ''
    }
  },
  computed: {
    ...mapGetters({
      globalState: 'globalVal/getState'
    }),
    isCopiedLink () {
      return (this.isCopiedUrl) ? 'message.button.copied' : 'message.button.copy_link'
    }
  },
  methods: {
    openModal (data = null, profileType = null) {
      if (data) {
        this.profile = { ...data }
        this.profileType = profileType || 'professional'
        let shareUrl = 'https://beneat.co/cleaner/' + data.id
        let sharetext = 'Highly recommend! ' + this.$options.filters.firstName(data.name) + ' @beneat'
        let twitterShareUrl = 'https://twitter.com/share?text=' + this.shareText + '&url=http://beneat.co/cleaner/' + data.id

        if (profileType && profileType === 'experience') {
          shareUrl = 'https://beneat.co/special-services/' + data.id
          sharetext = 'Highly recommend! ' + data.title + ' @beneat'
          twitterShareUrl = 'https://twitter.com/share?text=' + sharetext + '&url=http://beneat.co/special-services/' +
            data.id
        }

        this.shareUrl = shareUrl
        this.shareText = sharetext
        this.twitterShareUrl = twitterShareUrl
        this.$refs.modal.open()
      }
    },
    closeModal () {
      this.$refs.modal.close()
    },
    copyLink () {
      this.isCopiedUrl = true
      this.closeModal()
    },
    fbShare () {
      const url = this.shareUrl
      const title = this.profile.name
      let description = this.profile.description.replace(/\\/g, '')
      const image = this.profile.picture

      if (this.$i18n.locale === 'en') {
        description = this.profile.description_en.replace(/\\/g, '')
      }

      window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + description + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer')
      this.closeModal()
    }
  },
  mounted () {
    // this.shareUrl = 'https://beneat.co/cleaner/' + this.professional.id
    // this.shareText = 'Highly recommend! ' + this.$options.filters.firstName(this.professional.name) + ' @beneat'
    // this.twitterShareUrl = 'https://twitter.com/share?text=' + this.shareText + '&url=http://beneat.co/cleaner/' + this.professional.id
  }
}
</script>



// WEBPACK FOOTER //
// src/components/professional/components/ShareProfileModal.vue